import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 0 20px;
`;

const StyledPlayerInfoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	padding: 20px;
	border-radius: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledImage = styled.img<{ $online?: boolean }>`
	width: 50px;
	height: 50px;
	border-radius: 50px;
	user-select: none;
	pointer-events: none;
	padding: 2px;
	border: 2px solid #77de38;
	min-width: 50px;
`;

const StyledInfoNameContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;

	${Text} {
		color: #ffffff;

		&:first-child {
			font-weight: 500;
			font-size: 16px;
		}

		&:last-child {
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
			max-width: 230px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;

			span {
				font-weight: 400;
				opacity: 0.5;
			}
		}
	}
`;

const StyledSettingsItem = styled.div`
	display: grid;
	grid-template-columns: 20px 1fr 30px;
	align-items: center;
	gap: 10px;
	padding: 20px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledSettingsList = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	overflow: hidden;

	${StyledSettingsItem} {
		&:not(:first-child) {
			border-top: 1px solid rgba(255, 255, 255, 0.1);
		}
	}
`;

const StyledSettingsItemIcon = styled.div<{ $bgColor?: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 5px;
	background-color: ${(props) => props.$bgColor || 'rgba(255, 255, 255, 0.1)'};

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledContainer,
	StyledImage,
	StyledInfoNameContainer,
	StyledPlayerInfoContainer,
	StyledSettingsItem,
	StyledSettingsItemIcon,
	StyledSettingsList,
};
